// import BudgetProgress, { ProgressType } from 'components/budgetProgress/budgetProgress';
import {
  Anchor,
  Box,
  Button,
  Center,
  Group,
  PasswordInput,
  TextInput,
  Title,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useForm } from "@mantine/form";
import { Link } from "react-router-dom";
import { loginUser } from "../../authSlice";
import { IconLock, IconMail } from "@tabler/icons-react";
import { logger } from "utils/logger";
import { createStyles } from "@mantine/emotion";
// import Dashboard from './features/components/Dashboard';

const useStyles = createStyles((theme) => ({
  container: {
    // backgroundColor:'rgb(174 182 255 / 7%)',
    // backgroundColor:theme.black,
    // padding:`${theme.spacing.md *1}px`,
    borderRadius: theme.radius.md,
    width:'100%'
  },
  title: {
    color: theme.white,
  },

  input: {},
}));

const mapDispatch = { loginUser };

const Login = ({ success, error }) => {
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [success, error]);

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      username:
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_EMAIL
          : "",
      password:
        process.env.NODE_ENV === "development" ? process.env.REACT_APP_PW : "",
    },

    // validate: {
    //   confirmPassword: (value, values) =>
    //     value !== values.password ? 'Passwords did not match' : null,
    // },
  });

  const onSubmit = (values) => {
    logger.log("here", values);
    setIsLoading(true);
    dispatch(loginUser(values));
    //form.onSubmit((values) => logger.log(values))
  };

  // const containerStyle = { width:'1000px', marginTop:'20%', paddingLeft:'20%'}
  return (
    <Center style={{ width: "100%", height: "100%" }}>
      <Box style={{ width: "100%" }}>
        <Box className={classes.container}>
          <Title
            className={classes.title}
            order={1}
            mb="xl"
            sx={{ textAlign: "center" }}
          >
            Sign In
          </Title>
          <form onSubmit={form.onSubmit(onSubmit)}>
            <TextInput
              leftSection={<IconMail stroke={1} />}
              size="md"
              label="Email"
              placeholder="Enter username or email"
              className={classes.input}
              required
              {...form.getInputProps("username")}
            />

            <PasswordInput
              leftSection={<IconLock stroke={1} />}
              mt="lg"
              size="md"
              label="Password"
              placeholder="Enter password"
              required
              {...form.getInputProps("password")}
            />

            <Group mt="xl" mb="xl" position="apart">
              {/* <Checkbox label="Remember me"></Checkbox> */}
              <Anchor component={Link} to="/auth/forgotpassword" size={"sm"}>
                Forgot Password?
              </Anchor>
            </Group>

            <Group position="right" mt="xl" mb="lg">
              <Button
                size="md"
                radius={"xl"}
                fullWidth
                sx={{ width: "100%" }}
                type="submit"
                c={'white'}       
                loading={isLoading}
              >
                Log In
              </Button>
            </Group>
          </form>
        </Box>
        {/* <Center mt={'xl'}>
              <Link to="/auth/register" size='sm'>Don't have an account? Register.</Link>
            </Center> */}
      </Box>
    </Center>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    success: state.auth.success,
    error: state.auth.error,
  };
};

export default connect(mapStateToProps, mapDispatch)(Login);

// export default Auth;
// export default {
//     routeProps: {
//         path: '/auth',
//         component: Auth,
//     },
//     name: 'Auth',
// };
